import React, { useEffect } from 'react'
import CV from "../assets/current_resume.pdf"
import AOS from 'aos'
import 'aos/dist/aos.css'

const About = () => {

    useEffect(() => {
        AOS.init()
    }, [])

    return (
        <section>

            <div id='para-header'
                data-aos="fade-up"
                data-aos-offset="250"
                // data-aos-delay="100"
                data-aos-duration="800"
                data-aos-easing="ease">
                <small>(001)</small> WHO AM I?
            </div>

            <div id='para-bg'
                data-aos="fade-up"
                data-aos-offset="250"
                // data-aos-delay="100"
                data-aos-duration="800"
                data-aos-easing="ease"
            >
                ABOUT ME
            </div>

            <div id='para'
                data-aos="fade-up"
                data-aos-offset="250"
                data-aos-duration="800"
                data-aos-easing="ease">
                <h2> Hi, I'm<small> Agni</small>. </h2>
                <p>
                    I'm a <small>JunioR Full Stack DevelopeR</small> and currently in
                    Information Technology major at <small>Jadavpur University, India.</small>
                </p>
            </div>

            <div id='para'
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-offset="250"
                data-aos-easing="ease">
                <p>
                    I create projects with the belief that <small>“Less is more” </small>
                    and so I prefer minimalistic and clean design, that has a modern
                    appealing look.
                </p>
            </div>

            <div id='para'
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-offset="250"
                data-aos-easing="ease">
                <p>
                    I'm currently learning <small>GsAp</small> and <small>fRAmer Motion</small> to
                    further develop my skills in front-end <small>desiGning,</small>
                    while also honing my skills and knowledge in
                    the <small>backend</small> portion.
                </p>
            </div>

            <div id='para'
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-offset="250"
                data-aos-easing="ease">
                <p>
                    When I'm not coding or designing, you can either find me
                    making <small>sKetcHes,</small> or playing my <small>ukuLele</small> at
                    rooftop, or maybe in a pub hanging out with my friends.
                </p>
            </div>

            <a href={CV} download="Resume" target="_blank" rel="noreferrer">
                <button className="Button-Creation">
                    Download my Resume...
                </button>
            </a>

        </section>
    )
}

export default About